// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LBNdj","content":"styles_content__3LDVu"};